
































import { Component, Vue } from 'vue-property-decorator';

@Component
export default class Login extends Vue {
  private groupId: string = '';

  private valid: boolean = false;

  private name: string = '';

  private mounted() {
    this.groupId = new URLSearchParams(window.location.search).get('groupId') || '';
  }

  private submit() {
    if (!this.valid) {
      return;
    }

    this.$emit('submit', {
      name: this.name,
      groupId: this.groupId,
    });
  }
}
